import React, { useState } from 'react';
import { Box, Stack, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'gatsby';
import { SanityNavItem } from 'src/types/sanity/types.sanity.navItems';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';

import { navigate } from 'gatsby';

interface MobileNavItemsProps {
  navItems: SanityNavItem[] | null;
}

const menuIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="14" viewBox="0 0 34 14" fill="none">
    <line y1="1.26611" x2="34" y2="1.26611" stroke="#1A1919" stroke-width="2" />
    <line y1="12.2661" x2="34" y2="12.2661" stroke="#1A1919" stroke-width="2" />
  </svg>
);

const MobileNavItems = ({ navItems }: MobileNavItemsProps) => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setOpen(open);
  };

  return (
    <>
      <Box
      // mr={'34px'}
      >
        <IconButton onClick={toggleDrawer(true)}>{menuIcon}</IconButton>
      </Box>
      <Drawer
        anchor={'left'}
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: '80vw', // Set the width to 80% of the viewport width
            maxWidth: '100%', // Ensure it doesn't exceed 100% in smaller screens
          },
        }}
      >
        <Stack height={'100%'} p={['1.47rem']} justifyContent={'space-between'}>
          <Stack
            spacing={0}
            // p={['1.47rem']}
          >
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
              pb={'20px'}
            >
              <Typography
                variant={'body1'}
                color={'text.primary'}
                fontFamily="Everett Light"
                fontSize="29px"
              >
                Menu
              </Typography>
              <IconButton onClick={toggleDrawer(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            {navItems &&
              navItems.map(navItem => (
                <>
                  {navItem?.route?.link ? (
                    <Typography
                      component={'a'}
                      href={navItem?.route?.link}
                      variant={'body1'}
                      color={'text.primary'}
                      sx={{ textDecoration: 'none' }}
                      fontSize={'38px !important'}
                      fontFamily="Everett Light"
                    >
                      {navItem?.name}
                    </Typography>
                  ) : (
                    <>
                      <Typography
                        component={Link}
                        to={navItem?.route?.path}
                        variant={'body1'}
                        color={'text.primary'}
                        sx={{ textDecoration: 'none' }}
                        fontSize={'38px !important'}
                        fontFamily="Everett Light"
                      >
                        {navItem?.name}
                      </Typography>
                    </>
                  )}
                </>
              ))}
          </Stack>

          {/* Mobile Menu Footer */}
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} pb={'20px'}>
            <Box>
              <Typography
                variant={'body2'}
                component={Link}
                to="mailto:elo@elo.health"
                color={'#191919'}
              >
                elo@elo.health
              </Typography>
            </Box>
            <Box>
              <IconButton
                onClick={() => navigate('https://www.instagram.com/elo.health/?hl=en')}
                size="small"
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                onClick={() => navigate('https://www.linkedin.com/company/elo-health/')}
                size="small"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                onClick={() => navigate('https://m.facebook.com/EloHealth/')}
                size="small"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                onClick={() => navigate('https://twitter.com/elo_health?lang=en')}
                size="small"
              >
                <TwitterIcon />
              </IconButton>
            </Box>
          </Box>
        </Stack>
      </Drawer>
    </>
  );
};

export default MobileNavItems;
